import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { IIntegrationsMappings } from "../../services/IntegrationApi";
import { Button } from "../../UI/Button";
import { MappingFormModal } from "../MappingFormModal";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

export const IntegrationEditButton: React.FC<IIntegrationsMappings> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button onClick={openModal}>Edit</Button>
      </ReadOnlyWrapper>
      <MappingFormModal defaultProps={props} />
    </>
  );
};
